import { Config } from '@/api/http'
import { ProviderModule } from '@/store/modules/provider.module'
import { sessionKey, setSessionData } from '@/utils/storage.util'
import { isNullOrEmpty } from '@/utils/str.util'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/fe-subapp/index',
    component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue'),
    children: [
      {
        path: '/fe-subapp/index/:id',
        component: () => import(/* webpackChunkName: "right-content" */ '../components/index/RightContent.vue')
      }
    ]
  },
  {
    path: '/system_setting/account-manage',
    name: 'AccountManage',
    component: () => import(/* webpackChunkName: "account-manage" */ '../views/AccountSystem/AccountManage/AccountManage.vue'),
    meta: {
      title: '账号管理',
      keepAlive: true
    }
  },
  {
    path: '/system_setting/edit-group',
    component: () => import(/* webpackChunkName: "edit-group" */ '../views/AccountSystem/EditGroup/EditGroup.vue'),
    meta: {
      title: '账号管理'
    }
  },
  {
    path: '/system_setting/account-add',
    component: () => import(/* webpackChunkName: "account-add" */ '../views/AccountSystem/AccountAdd/AccountAdd.vue'),
    meta: {
      title: '账号管理'
    },
    children: [
      {
        path: 'detail',
        component: () => import(/* webpackChunkName: "account-add-detail" */ '../views/AccountSystem/AccountAdd/AccountDetail/AccountDetail.vue'),
        meta: {
          title: '客服详情'
        }
      },
      {
        path: 'other',
        component: () => import(/* webpackChunkName: "account-add-detail" */ '../views/AccountSystem/AccountAdd/AccountOther/AccountOther.vue'),
        meta: {
          title: '其他资料'
        }
      },
      {
        path: 'flextime',
        component: () => import(/* webpackChunkName: "account-add-detail" */ '../views/AccountSystem/AccountAdd/AccountFlextime/AccountFlextime.vue'),
        meta: {
          title: '弹性工作时间'
        }
      }
    ]
  },
  {
    path: '/monitor-screen',
    component: () => import(/* webpackChunkName: "monitor-screen" */ '../views/MonitorScreen/MonitorScreen.vue'),
    meta: {
      title: '监控大屏'
    }
  }, 
  {
    path: '/ticket-monitor-screen',
    component: () => import(/* webpackChunkName: "ticket-monitor-screen" */ '../views/TicketMonitorScreen/TicketMonitorScreen.vue'),
    meta: {
      title: '客服工单监控大屏'
    }
  },
  {
    path: '/demo',
    component: () => import(/* webpackChunkName: "demo" */ '../views/Demo/Demo.vue'),
    meta: {
      title: 'demo'
    }
  }
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/fe-subapp/index'
  // }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta?.title) {
    document.title = to.meta.title as string
  }
  if (!isNullOrEmpty(to.query)) {
    const token = to.query?._token as string
    if (token) {
      Config._token = token
      setSessionData(sessionKey.user_token, token)
    }
  }

  if (!ProviderModule.providerId) {
    await ProviderModule.getProviderInfo()
  }
  next()
})

export default router
